
const save_user = (user) => {
    localStorage.setItem('ent_user', JSON.stringify(user));
}

const get_user = () => {
    return localStorage.getItem('ent_user');
}

const logout_user = () => {
    return localStorage.removeItem('ent_user');
}


const is_user_loggedin = (usr) => {
    if (usr) {
        return true;
    } else {
        return false;
    }
}

export {save_user, get_user , logout_user , is_user_loggedin};

